module.exports = __webpack_public_path__ + "img/adult_rank.b52f5f0.png";